import React from 'react';
import { Flex } from '@banhala/ui-kit';
import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { ReviewerProfile } from './ReviewerProfile';
import { ReviewImage } from './ReviewImage';
import { ReviewContent } from './ReviewContent';
import { ReviewTpoList } from './ReviewTpoList';
import { DeliveryLeadDays } from './DeliveryLeadDays';
import { ReviewInfo } from './ReviewInfo';
import { ReviewCodiGoods } from './ReviewCodiGoods';
import { useNavigator } from 'shared/src/utils';
import { useLogClickReview } from '../../../hooks/useLogClickReview';

type ReviewCardProps = {
  review: GoodsReview;
  onPressImage?: (index: number) => void;
  onPressLike?: () => void;
  onPressCodiGoods?: () => void;
};

export const ReviewCard: React.FC<ReviewCardProps> = ({
  review,
  onPressImage,
}) => {
  const logClickReview = useLogClickReview();

  const { navigator } = useNavigator();
  return (
    <Flex
      padding={{ horizontal: 16, vertical: 16 }}
      gap={12}
      onPress={() => {
        logClickReview(review);
        navigator.moveToWebview(`/reviews/${review.sno}`);
      }}
    >
      <ReviewerProfile review={review} />

      <Flex.Row alignItems={'flex-start'}>
        <DeliveryLeadDays review={review} />
      </Flex.Row>

      <ReviewImage images={review.images_webp} onPressImage={onPressImage} />
      {review.has_codi_goods && <ReviewCodiGoods review={review} />}
      <ReviewInfo review={review} />
      <ReviewContent contents={review.contents} />

      <ReviewTpoList tpoTypes={review.tpo_types} />
    </Flex>
  );
};
